// API Configuration
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const API_ENDPOINTS = {
  // Auth
  login: `${API_BASE_URL}/auth/login`,
  register: `${API_BASE_URL}/auth/register`,
  logout: `${API_BASE_URL}/auth/logout`,
  me: `${API_BASE_URL}/auth/me`,
  forgotPassword: `${API_BASE_URL}/auth/forgot-password`,
  resetPassword: (token) => `${API_BASE_URL}/auth/reset-password/${token}`,
  
  // Courses
  courses: `${API_BASE_URL}/courses`,
  courseById: (id) => `${API_BASE_URL}/courses/${id}`,
  courseByPath: (path) => `${API_BASE_URL}/courses/path/${path}`,
  courseCategories: `${API_BASE_URL}/courses/categories`,
  
  // Categories
  categories: `${API_BASE_URL}/categories`,
  categoryById: (id) => `${API_BASE_URL}/categories/${id}`,
  categoryBySlug: (slug) => `${API_BASE_URL}/categories/slug/${slug}`,
  categoryStats: `${API_BASE_URL}/categories/stats`,
  
  // Testimonials
  testimonials: `${API_BASE_URL}/testimonials`,
  testimonialById: (id) => `${API_BASE_URL}/testimonials/${id}`,
  
  // Files
  files: `${API_BASE_URL}/files`,
  fileById: (id) => `${API_BASE_URL}/files/${id}`,

  // Payments & Enrollment
  createOrder: `${API_BASE_URL}/payments/order`,
  verifyPayment: `${API_BASE_URL}/payments/verify`,
  enrollmentById: (id) => `${API_BASE_URL}/payments/enrollment/${id}`,
  myEnrollments: `${API_BASE_URL}/payments/my-enrollments`,
  checkEnrollment: (courseId) => `${API_BASE_URL}/payments/check-enrollment/${courseId}`,
};

export { API_BASE_URL, API_ENDPOINTS };
export default API_ENDPOINTS;
